import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { hasPrivilege, USER_WRITE } from 'utils/privileges';
import { AdminOrHubTextLink } from 'components/AdminOrHubLink';
import DetailsDropdown from 'components/ContentInfo/DropdownInfo';
import { jsx as _jsx } from "react/jsx-runtime";
function TeamManagersDropdown(_ref) {
  var managers = _ref.managers,
    children = _ref.children;
  var areManagersVisible = hasPrivilege(USER_WRITE);
  var title = 'managers';
  var menuItems = managers.map(function (manager) {
    var id = manager.id,
      displayName = manager.displayName;
    var link = "/users?search=".concat(encodeURIComponent("id:".concat(id)));
    return /*#__PURE__*/_jsx(AdminOrHubTextLink, {
      bold: true,
      link: link,
      children: displayName
    }, id);
  });
  return /*#__PURE__*/_jsx(DetailsDropdown, {
    titleKey: title,
    listItems: menuItems,
    isDisabled: !areManagersVisible,
    children: children
  });
}
export default TeamManagersDropdown;